<template>
  <div>
    <CCardBody>
      <div class="d-flex gap-1 justify-content-end text-right btngroup">
        <CButton
            class="deleteBtn"
            @click="exportTemplate"
        >
          Export
        </CButton>
        <CButton
            class="deleteBtn"
            @click="importTemplate"
        >
          Import
        </CButton>
        <CButton
            class="addBtn"
            @click="showModal"
        >
          Create
        </CButton>
      </div>
      <search-items v-model="filters.search" :searchHandler="searchPrices"
                    placeholder="Search name"></search-items>
      <b-table :items="priceLists" :fields="headers" hover sorter>
        <template #cell(name)="item">
          <span>{{item.item.name}}</span>
        </template>
        <template #cell(discount_percentage)="item">
          <span>{{Math.floor(item.item.discount_percentage)}}%</span>
        </template>
        <template #cell(is_default)="item">
          <span>{{item.item.is_default  ? 'True' : 'False'}}</span>
        </template>
        <template #cell(actions)="item">
          <edit class="delete_step ml-2 cursor-pointer" @click="editPriceList(item.item)" fillColor="#009FE3" />
          <delete class="delete_step ml-2 cursor-pointer" @click="deletePriceList(item.item)" fillColor="#E30000" />
          <copy class="delete_step ml-2 cursor-pointer" @click="copyPriceList(item.item)" fillColor="#009FE3" />
        </template>
      </b-table>
      <b-pagination
          v-model="pagination.currentPage"
          :total-rows="pagination.rows"
          :per-page="pagination.perPage"
          aria-controls="itemList"
          align="center"
          @change="handlePagination"
          v-if="pagination.total > 0"
      ></b-pagination>
    </CCardBody>
    <b-modal id="priceListModal" @hide="resetForm"  size="xl" no-close-on-backdrop hide-footer>
      <template #modal-title>
        <span>{{modalTitle}}</span>
      </template>
      <b-tabs pills content-class="mt-3">
        <b-tab title="Basic" key="basic">
          <b-form-group id="name" label-for="name">
            <CContainer>
              <CRow>
                <CCol col="6">
                  <label>Name</label>
                  <b-form-input v-model="priceList.name" class="mb-4"></b-form-input>
                  <label>Reseller discount percentage</label>
                  <b-form-input type="number" v-model.number="priceList.discount_percentage" class="mb-4"></b-form-input>
                </CCol>
                <CCol col="6">
                  <label>Currency</label>
                  <v-select @option:selected="getSkusAgainstCurrencies(priceList.rules)" v-model="currency" value="id" :options="currencies" label="name" class="mb-4"></v-select>
                  <b-form-checkbox v-model="priceList.is_default" style="margin-top: 11%">
                    Is Default
                  </b-form-checkbox>
                </CCol>
              </CRow>
            </CContainer>
          </b-form-group>
        </b-tab>
        <b-tab title="Rules" key="rules">
          <template #title>
            Rules
          </template>
          <CCol col="12">
            <CRow>
              <template v-for="(rule, rule_idx) in priceList.rules">
                <div class="d-flex w-100 align-items-center gap-1 mb-3" :key="`price_rule_${rule_idx}`">
                  <div class="w-25">
                    <label>Select SKU</label>
                    <v-select :selectable="disableSelectedOption" :searchable="true" :disabled="currency === null" @option:selected="setPriceListRules(rule)" v-model="rule.sku" :options="skus" label="sku_id"></v-select>
                  </div>
                  <div class="w-20">
                    <label>Discount Percentage</label>
                    <b-form-input @input="calculateFinalPrice(rule)" type="number" :disabled="rule.sku_id === '' || rule.is_fixed" v-model.number="rule.discount_percentage" placeholder="Discount Percentage"></b-form-input>
                  </div>
                  <div class="w-20">
                    <label class="d-flex justify-content-between"><span>Fixed Price</span><b-form-checkbox v-model="rule.is_fixed"></b-form-checkbox></label>
                    <b-form-input type="number" :disabled="rule.sku_id === ''  || !rule.is_fixed" v-model.number="rule.fixed_price"></b-form-input>
                  </div>
                  <div class="w-20">
                    <label>Net Price</label>
                    <b-form-input type="number" disabled v-model.number="rule.original_price"></b-form-input>
                  </div>
                  <div class="w-20">
                    <label>Discounted Price</label>
                    <b-form-input type="number" disabled v-model.number="rule.price_after_discount"></b-form-input>
                  </div>
                  <delete :size="24" @click="removeRule(rule_idx)" fillColor="#E30000" class="cursor-pointer text-right mt-4" />
                </div>
              </template>
            </CRow>
            <span class="float-right text-black-50 mr-4">*Fixed price value will overwrite the discount percentage.</span>
            <CRow>
              <add class="cursor-pointer" :size="36" fillColor="#009FE3" @click="addRule"></add>
            </CRow>
          </CCol>
        </b-tab>
      </b-tabs>
      <CRow>
        <CCol col="12" class="text-right">
          <button @click="createEditPriceList" class="btn btn-primary">
            Save
          </button>
        </CCol>
      </CRow>
    </b-modal>
    <b-modal id="importExcelModal" size="md" no-close-on-backdrop hide-footer>
      <template #modal-title>
        <span>Import Price List</span>
      </template>
      <b-form>
        <b-form-group>
          <b-form-file v-model="price_list_template"></b-form-file>
        </b-form-group>
      </b-form>

      <CRow>
        <CCol col="12" class="text-right">
          <button @click="handlePriceListImport" class="btn btn-primary mt-3">
            Save
          </button>
        </CCol>
      </CRow>
    </b-modal>
    <b-modal id="deletePriceListModal" size="md" no-close-on-backdrop>
      <template #modal-title>
        <span>Delete Price List</span>
      </template>
      <h5>Are you sure you want to delete this price list?</h5>
      <template #modal-footer="{ hide }">
        <b-button size="md" variant="danger" @click="confirmDelete">Delete</b-button>
        <b-button size="md" @click="hide()">Cancel</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import myMixins from '@/mixins/myMixins';
import Copy from 'vue-material-design-icons/ContentCopy.vue';
import Delete from 'vue-material-design-icons/Delete.vue';
import Edit from 'vue-material-design-icons/Pencil.vue';
import Add from 'vue-material-design-icons/PlusBox.vue';
import SearchItems from "../../components/SearchItems";
import { http } from "../../config/httpCommon";

export default {
  components: {SearchItems, Delete, Edit, Add, Copy},
  mixins: [myMixins],
  created() {
    this.$store.dispatch('currencies');
    this.getPriceLists();
  },
  data() {
    return {
      filters:{
        search: '',
        page: 1,
      },
      headers: [
          {key: 'name', label: 'Name'},
          {key: 'discount_percentage', label: 'Discount Percentage'},
          {key: 'is_default', label: 'Default'},
          {key: 'actions', label: 'Actions'}
      ],
      priceList: {
        name: '',
        is_default: false,
        discount_percentage: 0,
        rules: [
          {
            sku: null,
            sku_id: '',
            discount_percentage: 0,
            is_fixed: false,
            fixed_price: 0,
            original_price: 0,
            price_after_discount: 0,
          }
        ],
      },
      currency: null,
      mode: 'create',
      priceListId: null,
      price_list_template: null,
      pagination:{
        rows:null,
        currentPage:null,
        perPage:null,
        total:0
      },
      priceLists: [],
    }
  },
  computed: {
    currencies() {
      return this.$store.getters.getCurrencies;
    },
    skus(){
      return this.$store.getters.getSkuAgainstCurrency;
    },
    hasEmptyProperties() {
      const { name, discount_percentage } = this.priceList;

      return [name, discount_percentage].some(
          value => value === '' || value === null || value === undefined
      );
    },
    modalTitle() {
      const priceList = this.priceLists.find((priceList) => priceList.id === this.priceListId)
      if (this.mode === 'edit') {
        return `Editing pricelist ${priceList.name}`;
      } else if (this.mode === 'copy') {
        return `Copying pricelist ${priceList.name}`;
      } else {
        return 'Create Price List'
      }
    },
  },
  methods: {
    searchPrices(){
      this.getPriceLists(this.filters.search, 1);
    },
    getPriceLists(search = '', page = 1) {
      http.get(`/pricelists?paginate=true&search=${search}&page=${page}`).then((res) => {
        this.priceLists = res.data.result.pricelists.data;
        this.makePagination(res.data.result.pricelists);
      });
    },
    createEditPriceList() {
        if (this.hasEmptyProperties) {
          this.showToast('Please fill all fields', 'ERROR');
          this.$store.commit('set', ['showLoader', false]);
          return;
        } else if (!this.currency) {
          this.showToast('Please select currency', 'ERROR');
          this.$store.commit('set', ['showLoader', false]);
          return;
        }
        this.$store.commit('set', ['showLoader', true]);
        this.priceList.currency_id = this.currency.id;
        if (this.priceList.rules[0].sku_id === '') {
          this.priceList.rules = [];
        } else {
          this.priceList.rules.forEach((rule) => {
            if (rule.is_fixed) {
              rule.discount_percentage = 0;
            }
            rule.sku_id = rule.sku.id;
            delete rule.sku;
            if (rule.id) {
              delete rule.id;
              delete rule.created_at;
              delete rule.updated_at;
              delete rule.deleted_at;
              delete rule.pricelist_id;
            }
          })
        }

        if (this.mode === 'edit') {
          this.$store.dispatch('updatePriceList', { id: this.priceListId, priceList: this.priceList }).then(() => {
            this.getPriceLists(this.filters.search, this.filters.page);
            this.$bvModal.hide('priceListModal');
            this.$store.commit('set', ['showLoader', false]);
            this.showToast('Price list updated successfully', 'SUCCESS')
          }).catch((err) => {
            this.$store.commit('set', ['showLoader', false]);
            this.handleResponseErrors(err);
          });
        } else {
          this.$store.dispatch('createPriceList', this.priceList).then(() => {
            this.getPriceLists(this.filters.search, this.filters.page);
            this.$bvModal.hide('priceListModal');
            this.$store.commit('set', ['showLoader', false]);
            this.showToast('Price list added successfully', 'SUCCESS')
          }).catch((err) => {
            this.$store.commit('set', ['showLoader', false]);
            this.handleResponseErrors(err);
          })
        }
    },
    editPriceList(item) {
      this.mode = 'edit';
      this.handlePriceList(item, { includeName: true });
    },
    deletePriceList(item) {
      this.priceListId = item.id;
      if (item.is_default) {
        this.$store.commit('set', ['showLoader', false]);
        this.showToast('Cannot delete default price list', 'WARNING');
        return;
      }
      this.$bvModal.show('deletePriceListModal');
    },
    confirmDelete() {
      this.$store.commit('set', ['showLoader', true]);
      this.$store.dispatch('deletePriceList', { id: this.priceListId }).then(() => {
        this.priceLists = this.$store.dispatch('getPriceList');
        this.$store.commit('set', ['showLoader', false]);
        this.$bvModal.hide('deletePriceListModal');
        this.showToast('Price list deleted successfully', 'SUCCESS');
      }).catch((err) => {
        this.$store.commit('set', ['showLoader', false]);
        this.handleResponseErrors(err);
      })
    },
    showModal() {
      this.$bvModal.show('priceListModal');
    },
    addRule() {
      this.priceList.rules.push({
        sku_id: '',
        discount_percentage: 0,
        is_fixed: false,
        fixed_price: 0,
        original_price: 0,
        price_after_discount: 0,
      });
    },
    removeRule(index) {
      if (this.priceList.rules.length > 1) {
        this.priceList.rules.splice(index, 1);
      }
    },
    calculateFinalPrice(rule) {
      rule.price_after_discount = (rule.original_price - (rule.original_price * (rule.discount_percentage / 100))).toFixed(2);
    },
    setPriceListRules(rule) {
      if (this.currency && rule.sku) {
        if (this.mode === 'edit') {
          let sku = this.skus.find((sku) => sku.id === rule.sku.id);
          rule.original_price = rule.sku.net_price ? rule.sku.net_price : 0;
          rule.price_after_discount = rule.original_price - (rule.original_price * (rule.discount_percentage / 100))
          rule.sku_id = sku.id;
        } else {
          rule.original_price = rule.sku.net_price ? rule.sku.net_price : 0;
          rule.price_after_discount = (rule.original_price - (rule.original_price * (rule.discount_percentage / 100))).toFixed(2);
          rule.sku_id = rule.sku.id;
        }
      } else {
        return 0
      }
    },
    disableSelectedOption(option) {
      const selectedSkus = this.priceList.rules
          .map((rule) => rule.sku && rule.sku.sku_id)
          .filter((sku_id) => sku_id !== null);
      return !selectedSkus.includes(option.sku_id);
    },
    getSkusAgainstCurrencies(rules) {
      if (this.mode === 'edit') {
        const priceList = this.priceLists.find((priceList) => priceList.id === this.priceListId);
        priceList.rules?.forEach((rule) => {
          this.setPriceListRules(rule);
        })
      }
      this.$store.dispatch('getSkuAgainstCurrencies', this.currency.id);
      rules.forEach((rule) => {
        if (rule.sku) {
          const sku = this.skus.find((sku) => sku.id === rule.sku.id);
          rule.original_price = sku.net_price ? sku.net_price : 0;
          this.calculateFinalPrice(rule);
        }
      })
    },
    resetForm(){
      this.priceList = {
        name: '',
        is_default: false,
        discount_percentage: 0,
        rules: [
          {
            sku: null,
            sku_id: '',
            discount_percentage: 0,
            is_fixed: false,
            fixed_price: 0,
            original_price: 0,
            price_after_discount: 0,
          }
        ]
      }
      this.currency = {};
      this.mode = 'create';
    },
    exportTemplate() {
      this.$store.commit('set', ['showLoader', true]);
      this.$store.dispatch('exportExcelTemplate').then(() => {
        this.$store.commit('set', ['showLoader', false]);
        this.showToast('Price Lists exported.', 'SUCCESS');
      }).catch((err) => {
        this.$store.commit('set', ['showLoader', false]);
        this.$bvModal.hide('importExcelModal')
        this.handleResponseErrors(err);
      });
    },
    importTemplate() {
      this.$bvModal.show('importExcelModal');
    },
    handlePriceListImport() {
      this.$store.commit('set', ['showLoader', true]);
      const formData = new FormData();
      formData.append('file', this.price_list_template);
      this.$store.dispatch('importExcelTemplate', formData).then(async () => {
        this.$store.commit('set', ['showLoader', false]);
        this.showToast('Prices imported successfully', 'SUCCESS');
        this.$bvModal.hide('importExcelModal')
      }).catch((err) => {
        this.$store.commit('set', ['showLoader', false]);
        this.$bvModal.hide('importExcelModal')
        this.handleResponseErrors(err);
      });
    },
    copyPriceList(item) {
      this.mode = 'copy';
      this.handlePriceList(item, { includeName: false });
    },
    async handlePagination(page = 1){
      this.filters.page = page;
      this.getPriceLists(this.filters.search, this.filters.page);
    },
    handlePriceList(item, { includeName }) {
      this.priceListId = item.id;
      const priceList = this.priceLists.find((priceList) => priceList.id === item.id);
      const selectedCurrency = this.currencies.find((currency) => currency.id === item.currency_id);

      Object.assign(this.priceList, {
        ...(includeName && { name: priceList.name }),
        is_default: priceList.is_default === true || priceList.is_default === 1,
        discount_percentage: priceList.discount_percentage,
        rules: priceList.rules.length ? priceList.rules.map((rule) => {
          return {
            sku: rule.sku,
            discount_percentage: rule.discount_percentage,
            is_fixed:rule.is_fixed == true || rule.is_fixed == 1,
            fixed_price: rule.fixed_price,
            original_price: rule.original_price,
            price_after_discount: rule.price_after_discount,
          }
        }) : this.priceList.rules,
      });

      this.$store.dispatch('getSkuAgainstCurrencies', selectedCurrency.id);

      this.currency = selectedCurrency;
      this.$bvModal.show('priceListModal');
    },
  }
}
</script>